import React from 'react';
export const en = {
  projectTeam: 'Project Team',
  generalTitle: 'General Settings',
  integrationsTitle: 'Integrations',
  installBugherd: 'Install BugHerd',
  sidebar: 'Sidebar',
  feedbackSettings: 'Sidebar Settings',
  tags: 'Tags',
  commitHook: 'Commit Hook',
  exportBugs: 'Export Bugs',
  disableDelete: 'Disable/delete project',
  advanced: 'Advanced',
  installBugherdTitle: 'Install BugHerd',
  securityTitle: 'Security',
  sidebarSettingsTitle: 'Sidebar Settings',
  editTagsTitle: 'Edit Tags',
  commitTitle: 'Set up a commit hook',
  advancedTitle: 'Advanced Settings',
  disableTitle: 'Disable/Delete project',
  disableCopy:
    "Here you can update your project settings. Please make sure you want to delete your project as you won't be able to retrieve it when it's gone.",
  disableButton: 'Project disabled',
  deleteButton: 'Delete project',
  enableButton: 'Project enabled',
  copy: 'Copy',
  guestPermissions: 'Client Settings',
  commitIntro:
    'You can configure your Version Control System with a hook and when you reference a BugHerd task, the commit message is added as a comment.',
  commitGit: `Copy and paste the URL below in to your GitHub project under Settings > Webhooks.`,
  commitGitlab: `Copy and paste the URL below in to your GitLab project under Settings > Integrations.`,
  commitBitbucket: `Copy and paste the URL below in to your Bitbucket project under Settings > Integrations > Webhooks.`,
  integrationsDescription:
    'Send tasks from BugHerd to your project management, communications and dev tools.',
  javascriptCodeDescription: [
    `Paste the code in your website's `,
    <code>{`<head>`}</code>,
    ' and Bugherd is ready for you, your client, and team.'
  ],
  javascriptCodeTitle: 'Install the Javascript code',
  javascriptCodeButtonLabel: `Get code`,
  browserExtensionDescription:
    'No code required. Simply add the extension to your browser and BugHerd will appear on your website for you.',
  browserExtensionTitle: 'Get the browser extension',
  browserExtensionButtonLabel: 'Get extension',
  wordpressPluginDescription:
    'The simplest way to install Bugherd on your WordPress site & admin.',
  wordpressPluginTitle: 'Install the WordPress plugin',
  wordpressPluginButtonLabel: 'Install plugin',
  recommended: ' (Recommended)',
  sendInstructions: ' or send instructions to a developer',
  send: 'Send',
  enterEmail: 'Enter email address',
  downloadThe: 'Download the ',
  bugherdWordpressPlugin: 'BugHerd Wordpress Plugin',
  activatePlugin: 'Activate the plugin using this Project Key:',
  copiedToClipboard: (script?: boolean) =>
    `Your project ${
      script ? 'javascript code' : 'key'
    } was successfully copied to the clipboard`,
  deliveredTo: 'Installation instructions will be delivered to ',
  tryAgain: 'Something went wrong, please try again',
  doneThis: `I've done this`,
  installed: 'Installed',
  overrideTitle: 'Use (CMD or CTRL) + Click to unset this',
  updating: 'Updating...',
  updatedProject: (ignore: boolean) =>
    `Validating the existence of the BugHerd javascript in your project sites has now been ${
      ignore ? 'disabled' : 'enabled'
    }.`,
  invalidEmail: 'Please enter a valid email address',
  integrationsGuideHeader: 'Integrating with BugHerd',
  integrationsGuideDescription:
    'See how to integrate BugHerd with your project management, communications and dev tools.',
  bestWorkflow: 'Choosing the right workflow',
  setItUp: 'See our integrations help articles',
  installingBugherd: 'Installing BugHerd',
  installMethod:
    'This guide will help you choose which install method is right for you, your team & clients.',
  clientFeedbackTipsHeader: 'Tips for managing client feedback',
  clientFeedbackTipsDescription:
    'Reduce the time it takes to manage Client feedback with these handy tips.',
  aiSettings: 'AI Settings',
  aiDuplicateTasksLabel: 'Finding potential similar tasks',
  aiSuggestedTitlesLabel: 'Auto-title generation for tasks',
  aiSuggestedTagsLabel: 'Auto-tagging tasks',
  aiSuggestedTagsExistingOnlyLabel:
    'AI should only suggest tags already in use on the project',
  aiSuggestedTitlesDefaultLanguageLabel:
    'Default language for generated titles (e.g., en-US)',
  disabledForAllProjects: 'Disabled for all projects',
  enabledForAllProjects: 'Enabled for all projects',
  improveAI: 'How can we improve our AI?',
  suggestImprovements: 'Suggest improvements',
  save: 'Save',
  aiBannerDescription: `Choose how you'd like AI to assist your team when using BugHerd in this project.`,
  aiBannerTitle: 'BugHerd AI',
  beta: 'Beta',
  aiHelpWithHeader: 'What does AI help with in BugHerd?',
  betaOptInTitle: 'AI features to assist your team using BugHerd',
  betaOptInDescription: `These features are current in open beta. Click 'Enable' to get early access for your Organization. You can opt-out at any time.`,
  enableBeta: 'Enable beta',
  betaNowEnabled: 'AI beta is now enabled for your Organization',
  disableBeta: 'Disable beta',
  betaNowDisabled: 'AI beta is now disabled for your Organization',
  confirmDisableBetaTitle:
    'This will disable the beta for your entire Organization.',
  confirmDisableBetaContent: 'Do you wish to proceed?',
  cancel: 'Cancel',
  overrideProjectSettings: 'These settings override project-level AI settings.',
  moreInfo: 'More info',
  organizationSettingsUpdated: 'Organization AI settings updated successfully',
  organizationSettingsUpdateError:
    'Something went wrong while updating organization settings, please try again later.',
  refetchOrganizationError:
    'Something went wrong while retrieving the updated Organization settings, please refresh the page.',
  selectLanguagePlaceholder: 'Search to select a Locale',
  noResultsFound: 'There are no results for these search parameters.',
  automaticallyDetectLanguage: 'Automatically detect language'
};

export type Translations = typeof en;
